import { Button, Row } from "antd";

type ModalFooterProps = {
  isLoading: boolean;
  send: () => void;
  close: () => void;
};

export const ModalFooter = ({ isLoading, send, close }: ModalFooterProps) => {
  return (
    <Row className="justify-end mt-10">
      <Button
        type="primary"
        size="large"
        shape="round"
        disabled={isLoading}
        loading={isLoading}
        onClick={send}
      >
        Request
      </Button>
      <Button
        size="large"
        className="ml-2"
        shape="round"
        disabled={isLoading}
        onClick={close}
      >
        Cancel
      </Button>
    </Row>
  );
};
